import { createAction, props } from '@ngrx/store';
import {Organization} from '../../../services/api/organizations/models/organization.model';

export const loadCurrentOrganization = createAction(
  '[CurrentOrganization] Load Current Organization'
);

export const loadCurrentOrganizationSuccess = createAction(
  '[CurrentOrganization] Load Current Organization Success',
  props<{ data: Organization }>()
);

export const loadCurrentOrganizationFailure = createAction(
  '[CurrentOrganization] Load Current Organization Failure',
  props<{ error: any }>()
);

export const clearCurrentOrganizationState = createAction(
  '[CurrentOrganization] Clear Current Organization State',
);
